import type { Nation } from '@seventide/types';

export type NationBannerModule = 'gifts' | 'money' | 'care' | 'health' | 'attorney' | 'documents' | 'benefits';

/**
 * Where rules are only partially adapted outside England (R-4.2):
 * - care finances and CHC/health differ in Scotland, Wales and Northern Ireland;
 * - benefits (Attendance Allowance) differ in Scotland (Pension Age Disability Payment) and NI;
 * - attorney records: Scotland (OPG Scotland, continuing/welfare powers) and NI (Office of Care and Protection).
 * IHT/gifts, money and documents are UK-wide.
 */
const PARTIAL: Record<NationBannerModule, Nation[]> = {
  gifts: [],
  money: [],
  documents: [],
  care: ['scotland', 'wales', 'northern_ireland'],
  health: ['scotland', 'wales', 'northern_ireland'],
  benefits: ['scotland', 'northern_ireland'],
  attorney: ['scotland', 'northern_ireland'],
};

export function partialRulesFor(module: NationBannerModule, nation: Nation): boolean {
  return PARTIAL[module].includes(nation);
}
